import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME, DEFAULT_DESCRIPTION, DEFAULT_KEYWORDS } from "../../config/siteConfig";

/**
 * Per-page SEO meta: title, description, canonical, Open Graph, Twitter Card.
 */
export default function PageMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords,
  canonicalPath,
  image,
  imageAlt,
  type = "website",
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonical = canonicalPath ? `${SITE_URL}${canonicalPath.startsWith("/") ? "" : "/"}${canonicalPath}` : null;
  const imgPath = typeof image === "string" ? image : (image?.src ?? null);
  const ogImage = imgPath
    ? (imgPath.startsWith("http") ? imgPath : `${SITE_URL}${imgPath}`)
    : `${SITE_URL}/companylogo2.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {(keywords || DEFAULT_KEYWORDS) && <meta name="keywords" content={keywords || DEFAULT_KEYWORDS} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical || SITE_URL} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="zh_HK" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
